import AddIcon from '@mui/icons-material/Add';
import ArchiveIcon from '@mui/icons-material/Archive';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import UnarchiveOutlinedIcon from '@mui/icons-material/UnarchiveOutlined';
import { IconButton, Tooltip } from '@mui/material';
import { WsColors } from 'wisestep-base';

export const EditIconButton = ({ onClick }) => (
  <IconButton onClick={onClick}>
    <EditIcon sx={{ fill: WsColors.TheBlues500, cursor: 'pointer' }} fontSize={'small'} />
  </IconButton>
);

export const SaveIconButton = ({ onClick }) => (
  <IconButton onClick={onClick}>
    <SaveIcon sx={{ fill: WsColors.TheBlues500, cursor: 'pointer' }} fontSize={'small'} />
  </IconButton>
);

export const AddIconButton = ({ onClick }) => (
  <IconButton onClick={onClick}>
    <AddIcon sx={{ fill: WsColors.TheBlues500, cursor: 'pointer' }} fontSize={'small'} />
  </IconButton>
);
export const DeleteIconButton = ({ onClick }) => (
  <IconButton onClick={onClick}>
    <DeleteIcon sx={{ fill: WsColors.Red500, cursor: 'pointer' }} />
  </IconButton>
);

export const CloseIconButton = ({ onClick }) => (
  <IconButton onClick={onClick}>
    <CloseIcon sx={{ fill: WsColors.Red500, cursor: 'pointer' }} />
  </IconButton>
);

export const ArchiveIconButton = ({ onClick, toolTipTitle = 'Archive' }) => (
  <IconButton onClick={onClick}>
    <Tooltip title={toolTipTitle}>
      <ArchiveIcon sx={{ cursor: 'pointer' }} color="primary" fontSize={'small'} />
    </Tooltip>
  </IconButton>
);

export const UnarchiveIconButton = ({ onClick, toolTipTitle = 'Restore' }) => (
  <IconButton onClick={onClick}>
    <Tooltip title={toolTipTitle}>
      <UnarchiveOutlinedIcon sx={{ cursor: 'pointer' }} color="primary" fontSize={'medium'} />
    </Tooltip>
  </IconButton>
);
